import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import { ReactSVG } from "react-svg";

import { MessageKey, useT } from "@/i18n";

type NotFoundProps = {
  btnTitle?: string;
  noText?: string;
  link?: any;
  pageTitle?: MessageKey;
};

const NotFoundComp = (props: NotFoundProps) => {
  const t = useT();

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {props.pageTitle && (
          <Box>
            <Typography variant="heading1">{t(props?.pageTitle)}</Typography>
          </Box>
        )}
        {props.btnTitle && (
          <Button
            size="small"
            color="primary"
            // disabled={auth.leagueId ? false : true}
            startIcon={
              <ReactSVG
                src="/images/addw.svg"
                style={{
                  marginTop: "4px",
                  paddingLeft: "5px",
                }}
              />
            }
            sx={{
              height: "36px",
              textTransform: "uppercase",
            }}
            variant="contained"
            onClick={props.link}
          >
            {props.btnTitle}
          </Button>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="heading1" sx={{ py: 10 }}>
          {props.noText}
        </Typography>
      </Box>
    </React.Fragment>
  );
};
export default NotFoundComp;
